import * as React from "react"
const EditBaselineIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    viewBox="0 0 300 300"
    {...props}
  >
    <g transform="matrix(1.34893 0 0 1.1847 -52.34 -27.705)">
      <path
        fill="#777"
        d="M161.058 61.704h-23.214v76.385h23.214V61.704Zm-35.393 0h47.572L150 27.28l-24.335 34.423ZM161.058 238.296h-23.214v-76.385h23.214v76.385Zm-35.393 0h47.572L150 272.72l-24.335-34.423Z"
      />
      <rect
        width={214.808}
        height={6.184}
        fill="#f80505"
        rx={0}
        ry={0}
        transform="matrix(1 0 0 3.85207 42.596 138.089)"
      />
    </g>
  </svg>
)
export default EditBaselineIcon
